'use client';
// ═══════════════════════════════════════════════════════════════════════════
// SATELLITE — pare-feu des composants d'accompagnement (incident 24/08/2026).
//
// L'ErrorBoundary de layout-client ne protège que renderPage(). Les composants
// montés À CÔTÉ de la page (RelatedModules, IdleLogout, HealthSweepOverlay…)
// étaient à nu : le 24/08, un snapshot instable dans RelatedModules (#2292) a
// fait remonter le crash au boundary RACINE — app entière en global-error,
// « Réessayer » inutile, ~40 min d'indisponibilité totale.
//
// Règle structurelle : un satellite qui crashe DISPARAÎT (il est accessoire par
// définition — un bloc de suggestions ne justifie jamais d'éteindre la paie).
// Le crash est signalé UNE fois à /api/error-logs (donc compté par le
// détecteur de panne totale), jamais re-jeté.
//
// Verrou : __tests__/layout-satellites-confines.test.js — tout satellite de
// layout-client doit être monté DANS <Satellite> ; un nouveau satellite nu
// fait échouer la suite.
// ═══════════════════════════════════════════════════════════════════════════
import React from 'react';
// authFetch et pas fetch nu (verrou fetch-nu-interdit) : il pose le jeton
// quand une session existe et part quand même sans (crash avant login).
import { authFetch } from '@/app/lib/auth-fetch';

// Dédup au niveau MODULE, pas instance : React rejoue le rendu après une
// erreur (nouvelle instance de boundary) — sans ça, un seul crash se
// signalerait deux fois, et une boucle de remount inonderait error_logs.
const _dernierSignal = new Map(); // label → timestamp
const SIGNAL_FENETRE_MS = 30000;

export default class Satellite extends React.Component {
  constructor(props) {
    super(props);
    this.state = { mort: false };
  }

  static getDerivedStateFromError() {
    return { mort: true };
  }

  componentDidCatch(error) {
    const label = this.props.label || 'inconnu';
    const dernier = _dernierSignal.get(label) || 0;
    if (Date.now() - dernier < SIGNAL_FENETRE_MS) return;
    _dernierSignal.set(label, Date.now());
    try {
      console.error('[Satellite]', this.props.label || 'satellite', 'désactivé après crash :', error?.message);
      authFetch('/api/error-logs', {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          level: 'error',
          source: 'satellite:' + label,
          message: String(error?.message || error || 'Erreur inconnue').slice(0, 1500),
          stack: String(error?.stack || '').slice(0, 1800),
          url: typeof window !== 'undefined' ? window.location.href : '',
        }),
      }).catch(() => {});
    } catch (_) { /* le signalement ne re-crashe jamais */ }
  }

  render() {
    if (this.state.mort) return null; // accessoire cassé = accessoire absent
    return this.props.children;
  }
}
